<template>
  <el-container direction="vertical">
    <div class="pcContainer" v-if="!isMobile">
      <el-header>
        <div class="left-menu">
          <div class="left_logo" @click="goIndex">
            <img src="https://img.i2soft.net/i2official-web/assets/images/nav/navLogo.png" alt="" />
            <div style="font-size: 20px; font-weight: normal; line-height: 20px; letter-spacing: 0px; color: #333333; margin-left: 20px; width: 250px">证券代码920799</div>
          </div>
          <div class="home-navmenu">
            <el-menu mode="horizontal" :default-active="activeIndex" router @select="handleSelect">
              <el-menu-item index="/first">
                <div class="menu-item">
                  <span>首页</span>
                  <div class="line-group" v-if="activeIndex === '/first'">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
              </el-menu-item>
              <el-menu-item index="/introduce">
                <div class="menu-item">
                  <span>公司介绍</span>
                  <div class="line-group" v-if="activeIndex === '/introduce'">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
              </el-menu-item>
              <el-menu-item index="/product">
                <div class="menu-item">
                  <span>创新产品</span>
                  <div class="line-group" v-if="activeIndex === '/product'">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
              </el-menu-item>
              <el-menu-item index="/solve">
                <div class="menu-item">
                  <span>解决方案</span>
                  <div class="line-group" v-if="activeIndex === '/solve'">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
              </el-menu-item>
              <el-menu-item index="/dynamic">
                <div class="menu-item">
                  <span>公司动态</span>
                  <div class="line-group" v-if="activeIndex === '/dynamic'">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
              </el-menu-item>
              <el-menu-item index="/relations">
                <div class="menu-item">
                  <span>投资者关系</span>
                  <div class="line-group" v-if="activeIndex === '/relations'">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
              </el-menu-item>
              <el-menu-item index="/joinUs">
                <div class="menu-item">
                  <span>加入我们</span>
                  <div class="line-group" v-if="activeIndex === '/joinUs'">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </el-header>
      <el-main style="padding: 0; margin-top: 1px; background-color: #eff0f4; width: 100%">
        <router-view></router-view>
        <Footer @footerLinkClick="footerLinkClick"></Footer>
      </el-main>
    </div>
    <PhoneHome v-else />
  </el-container>
</template>

<script>
  import Footer from "@/components/footer.vue";
  import { isMobile } from "@/utils/index";
  import PhoneHome from "./PhoneHome.vue";

  export default {
    components: { Footer, PhoneHome },
    data() {
      return {
        activeIndex: "",
        isMobile: false,
        isMenuShow: false,
        active: "",
        block: "",
      };
    },
    created() {},
    mounted() {
      this.handelPath(this.$route.path);
      this.isMobile = isMobile();
    },
    computed: {
      is_after_scroll() {
        return this.$store.state.account.afterScroll;
      },
    },
    watch: {
      "$route.path"(newPath) {
        this.handelPath(newPath);
      },
    },
    methods: {
      handleSelect(index) {
        this.activeIndex = index;
        this.isMenuShow = false;
        localStorage.setItem("activeIndex", index);
      },

      handelPath(routePath) {
        if (routePath == "/recruit" || routePath == "/examList") {
          // 招聘考试特殊处理，路由暂不可动（涉及笨鸟招聘考试链接）
          this.activeIndex = "/joinUs";
        } else if (routePath == "/internal") {
          this.activeIndex = "/dynamic";
        } else if (routePath == "/Announce" || routePath == "/government" || routePath == "/Achievement" || routePath == "/Service") {
          this.activeIndex = "/relations";
        } else {
          this.activeIndex = routePath;
        }
        localStorage.setItem("activeIndex", this.activeIndex);
      },

      modelRightMenu() {
        this.isMenuShow = true;
      },
      hideMenu() {
        this.isMenuShow = false;
      },
      // 底部-快速链接
      footerLinkClick(info) {
        this.$router.push({ path: info.path });
        this.activeIndex = info.path;
        this.isMenuShow = false;
      },
      goIndex() {
        this.$router.push({ path: "/first" });
        this.activeIndex = "/first";
      },
    },
  };
</script>

<style lang="less" scoped>
  .pcContainer {
    width: 100%;
    position: relative;

    .el-header {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 100;
      overflow: hidden;
      background-color: #fff;
      height: 100px !important;
      display: flex;
      align-items: center;

      .left-menu {
        width: 75%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .left_logo {
          cursor: pointer;
          display: flex;
          text-align: left;
          justify-content: center;
          align-items: center;
          font-size: 16px;

          img {
            width: 151px;
            height: 40px;
          }

          .textSpan {
            margin-left: 24px;
          }
        }
        .home-navmenu {
          height: 100%;
          display: flex;
          align-items: flex-end;

          .el-menu--horizontal {
            width: 100%;
            border-bottom: none;
            .el-menu-item {
              font-size: 18px;
            }

            .menu-item {
              display: flex;
              flex-direction: column;
              row-gap: 8px;

              .line-group {
                display: flex;
                flex-direction: column;
                align-items: center;
                row-gap: 8px;

                div:first-child {
                  width: 38px;
                  border: 1px solid #b08d57;
                }

                div:last-child {
                  width: 20px;
                  border: 1px solid #b08d57;
                }
              }
            }

            .el-menu-item.is-active {
              color: #b08d57;
              font-weight: 700;
              border: none;
            }
          }

          ul {
            // background: red;
            display: flex;

            li {
              list-style-type: none;
              margin: 0 25px;
              padding: 0;
            }
          }
        }
      }
    }

    .el-main {
      position: absolute;
      top: 80px;
      left: 0px;
    }

    /deep/ .el-menu--horizontal > .el-menu-item {
      line-height: normal;
    }
  }
</style>
